import { ReturnWasteInfoViewModel } from 'inventory.root/shared/models/return-waste-info.model';

export class ReturnWasteHistoryViewModel {
  dispenseUserName: string;
  returnWasteInfos: ReturnWasteInfoViewModel[];
}
